import { createStore, compose, applyMiddleware} from 'redux';
import thunkMiddleware from 'redux-thunk';

const reducer = process.env.REACT_APP_NAME === 'store' ?
require("../reducers/storeapp").default : require("../reducers/index").default

const middlewares = [];

middlewares.push(thunkMiddleware);

if (process.env.NODE_ENV === `development`) {
    const {
      	logger
    } = require(`redux-logger`);

    middlewares.push(logger);
}

const globalStore = createStore(
	reducer,
	compose(
		applyMiddleware(...middlewares),
	)
)

export const getToken = () => (globalStore.getState().loginReducer.data.token || null);

export default globalStore